export default "__VITE_ASSET__CdZi1w3t__"